import { render, staticRenderFns } from "./AvailabilityCalendar.vue?vue&type=template&id=21b1f3d6&scoped=true"
import script from "./AvailabilityCalendar.vue?vue&type=script&lang=js"
export * from "./AvailabilityCalendar.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityCalendar.vue?vue&type=style&index=0&id=21b1f3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b1f3d6",
  null
  
)

export default component.exports